/* Built In Imports */
/* External Imports */
import { Box } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import CommonComponents from '@lb/Common/CommonComponents';
import StyleConfig from '@lb/Common/StyleConfig';
import AboutDeviSlide1 from '@lb/Sections/aboutDevi/AboutDeviSlide1';
import AboutDeviSlide10 from '@lb/Sections/aboutDevi/AboutDeviSlide10';
import AboutDeviSlide11 from '@lb/Sections/aboutDevi/AboutDeviSlide11';
import AboutDeviSlide12 from '@lb/Sections/aboutDevi/AboutDeviSlide12';
import AboutDeviSlide13 from '@lb/Sections/aboutDevi/AboutDeviSlide13';
import AboutDeviSlide14 from '@lb/Sections/aboutDevi/AboutDeviSlide14';
import AboutDeviSlide15 from '@lb/Sections/aboutDevi/AboutDeviSlide15';
import AboutDeviSlide16 from '@lb/Sections/aboutDevi/AboutDeviSlide16';
import AboutDeviSlide17 from '@lb/Sections/aboutDevi/AboutDeviSlide17';
import AboutDeviSlide2 from '@lb/Sections/aboutDevi/AboutDeviSlide2';
import AboutDeviSlide3 from '@lb/Sections/aboutDevi/AboutDeviSlide3';
import AboutDeviSlide4 from '@lb/Sections/aboutDevi/AboutDeviSlide4';
import AboutDeviSlide5 from '@lb/Sections/aboutDevi/AboutDeviSlide5';
import AboutDeviSlide6 from '@lb/Sections/aboutDevi/AboutDeviSlide6';
import AboutDeviSlide7 from '@lb/Sections/aboutDevi/AboutDeviSlide7';
import AboutDeviSlide8 from '@lb/Sections/aboutDevi/AboutDeviSlide8';
import AboutDeviSlide9 from '@lb/Sections/aboutDevi/AboutDeviSlide9';
import RelatedContentSlider from '@lb/components/Blogs/RelatedContentSlider';
import VisitBhairaviSlider from '@lb/components/Sliders/VisitBhairaviSlider';

/**
 * Renders Render LB About Devi Sections
 *
 * @param {object} sectionContent - Data
 * @param {string} region - Region of Page
 * @param {string} lang - Language of Page
 * @returns {ReactElement} Render MSR Sections
 */

const RenderSectionsDevi = ({
  section,
  region,
  lang,
  pType,
  csrData,
  headerMenuData,
  topMenuData,
  pageData,
}) => {
  const { sectionId } = section;
  if (
    sectionId === 'visit-bhairavi-1' ||
    sectionId === 'visit-bhairavi-3' ||
    sectionId === 'visit-bhairavi-2'
  ) {
    return (
      <>
        <VisitBhairaviSlider
          section={section}
          region={region}
          lang={lang}
          sectionId={sectionId}
        />
      </>
    );
  } else if (sectionId === 'About_Devi_slide_1') {
    return (
      <>
        <AboutDeviSlide1 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'About_Devi_slide_2') {
    return (
      <>
        <AboutDeviSlide2 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'About_Devi_slide_3') {
    return (
      <>
        <AboutDeviSlide3 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Earn_Devi_Grace') {
    return (
      <>
        <AboutDeviSlide4 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Birth_Goddess_Slide_1') {
    return (
      <>
        <AboutDeviSlide5 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Birth_Goddess_Slide_2') {
    return (
      <>
        <AboutDeviSlide6 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Birth_Goddess_Slide_3') {
    return (
      <>
        <AboutDeviSlide7 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Uniqueness_Devi_360') {
    return (
      <>
        <AboutDeviSlide8 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Science_of_Creating_Goddesses_Transiction') {
    return (
      <>
        <AboutDeviSlide9 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Science_of_Creating_Goddesses_Slide_1') {
    return (
      <>
        <AboutDeviSlide10 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Science_of_Creating_Goddesses_Slide_2') {
    return (
      <>
        <AboutDeviSlide11 section={section} region={region} lang={lang} />
      </>
    );
  }
  // } else if (sectionId === 'Science_of_Creating_Goddesses_Slide_3') {
  //   return (
  //     <>
  //       <AboutDeviSlide12 section={section} region={region} lang={lang} />
  //     </>
  //   );
  // }
  else if (sectionId === 'Source_Creation_Slide_1') {
    return (
      <>
        <AboutDeviSlide12 section={section} region={region} lang={lang} />
        <AboutDeviSlide13 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Source_Creation_Slide_1.1') {
    return (
      <>
        <AboutDeviSlide14 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Source_Creation_Slide_2') {
    return (
      <>
        <AboutDeviSlide15 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Dark_One_Slide_1') {
    return (
      <>
        <AboutDeviSlide16 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'Dark_One_Slide_2') {
    return (
      <>
        <AboutDeviSlide17 section={section} region={region} lang={lang} />
      </>
    );
  } else if (sectionId === 'homepage-blog-list') {
    return (
      <RelatedContentSlider
        region={region}
        lang={lang}
        style={sectionId}
        section={section}
        sectionContent={section.sectionContent[0]?.tabs[0]?.cards}
        title={section.sectionContent?.title}
        subTitle={section.sectionContent[0]?.tabs[0]?.title}
      />
    );
  } else {
    return (
      <Box as="div" display="block" placeContent="center">
        {section?.sectionContent && section?.sectionContent?.length
          ? section?.sectionContent?.map((secCon, i) => {
              return (
                <StyleConfig
                  id={section?.sectionId}
                  key={section?.sectionId}
                  style={section?.styleConfig}
                  section={section}
                  pB={{ base: '0', md: '15px' }}
                >
                  <CommonComponents
                    key={nanoid()}
                    sectionContent={secCon}
                    section={section}
                    region={region}
                    language={lang}
                    pType={pType}
                    csrData={csrData}
                    pageData={pageData}
                    index={i}
                  />
                </StyleConfig>
              );
            })
          : null}
      </Box>
    );
  }
};

export default RenderSectionsDevi;
